// src/context/AppContext.jsx (Corrected and Final)

import { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // ✅ RE-ADD THE LOCATION STATE
  const [location, setLocation] = useState(() => {
    const stored = localStorage.getItem("userLocation");
    return stored ? JSON.parse(stored) : null;
  });

  // --- Auth State ---
  const [userID, setUserID] = useState(
    () => localStorage.getItem("userID") || null
  );
  const [accessToken, setAccessToken] = useState(
    () => localStorage.getItem("userAccessToken") || null
  );
  const [refreshToken, setRefreshToken] = useState(
    () => localStorage.getItem("userRefreshToken") || null
  );

  // --- App-wide UI State ---
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(!!accessToken);
  const [isAuthLoading, setIsAuthLoading] = useState(true); // Changed default to true

  // --- Sync state with localStorage ---

  // ✅ SYNC LOCATION TO LOCALSTORAGE
  useEffect(() => {
    if (location)
      localStorage.setItem("userLocation", JSON.stringify(location));
    else localStorage.removeItem("userLocation");
  }, [location]);

  useEffect(() => {
    if (userID) localStorage.setItem("userID", userID);
    else localStorage.removeItem("userID");
  }, [userID]);

  useEffect(() => {
    if (accessToken) localStorage.setItem("userAccessToken", accessToken);
    else localStorage.removeItem("userAccessToken");
  }, [accessToken]);

  useEffect(() => {
    if (refreshToken) localStorage.setItem("userRefreshToken", refreshToken);
    else localStorage.removeItem("userRefreshToken");
  }, [refreshToken]);

  // Centralized Logout Function
  const handleLogout = () => {
    setAccessToken(null);
    setRefreshToken(null);
    setUserID(null);
    setIsAuthenticated(false);
  };

  // This effect handles the initial authentication check ONCE when the app loads.
  useEffect(() => {
    // This logic is now simpler. We just determine the initial auth state.
    // The interceptor will handle validation and refreshing on actual API calls.
    if (accessToken && refreshToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setIsAuthLoading(false); // We are done with the initial check.
  }, [accessToken, refreshToken]); // Empty dependency array ensures this runs only on mount.

  // This effect listens for global logout events (e.g., from the axios interceptor)
  useEffect(() => {
    const performLogout = () => {
      handleLogout();
      setShowLoginModal(true);
    };
    window.addEventListener("logout", performLogout);
    return () => window.removeEventListener("logout", performLogout);
  }, []);

  return (
    <AppContext.Provider
      value={{
        showLoginModal,
        setShowLoginModal,
        location, // ✅ EXPOSE LOCATION
        setLocation, // ✅ EXPOSE SETTER
        userID,
        setUserID,
        accessToken,
        setAccessToken,
        refreshToken,
        setRefreshToken,
        isAuthenticated,
        setIsAuthenticated,
        handleLogout,
        isAuthLoading,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
